module.exports = __webpack_public_path__ + "static/media/operations.e77cec23.jpg";